export const BREAKPOINTS = {
  TINY: 480,
  MOBILE: 576,
  TABLET: 768,
  SMALL_DESKTOP: 992,
};

export const STORAGE_KEYS = {
  AUTH_TOKEN: 'oct_ads_token',
  FILTERS: 'oct_ads_filters',
  UI: 'oct_ads_ui',
};

export const CHART_COLORS = ['#c2710f', '#d4a041', '#e4b86a', '#FF8042', '#8884d8', '#82ca9d'];

export const DEFAULT_FILTERS = {
  project: 'fax',
  interval: 'day',
  dateRange: 'last7Days',
  campaignId: '',
  excludeNoInstalls: false,
};

/**
 * Presets that are recomputed from "today" on every load, so a saved or shared
 * "Last 7 Days" keeps rolling instead of freezing on the day it was picked.
 */
export const RELATIVE_PRESETS = new Set([
  'today',
  'yesterday',
  'thisWeek',
  'last7Days',
  'thisMonth',
  'last30Days',
  'lastMonth',
]);
